module.exports = __webpack_public_path__ + "img/fastvaluedeal-reviewer.3df372e8.png";